import type { FC } from "react";
import React from "react";

import { Tag } from "../../index";

import type { TagDefaultPresetProps } from "../types";

const DEFAULT_PRESET_TEST_ID = "tag-preset-test-id";

/**
 * Компоненты пресеты на основе компонента Tag с заданными свойствами, в которые необходимо передать текст.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=2337-3005&t=SrBFikddlzlRgrWT-0" target="_blank">Все пресеты</a>
 */
export const TagDefaultPreset: FC<TagDefaultPresetProps> = (props) => {
    const { label, ...restProps } = props;

    return (
        <Tag {...restProps} data-tsid={DEFAULT_PRESET_TEST_ID}>
            <Tag.Label>{label}</Tag.Label>
        </Tag>
    );
};
